const imports = require("../../../../lib");
module.exports = imports.stronachgroup.first.external;

const grpc = {};
grpc.web = require("grpc-web");
